export default function STDEVP() {
  return (
    <div className="p-4">
      <h1>STDEV.P</h1>
    </div>
  );
}
